import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tiny-tots',
  templateUrl: './tiny-tots.component.html',
  styleUrls: ['./tiny-tots.component.scss']
})
export class TinyTotsComponent implements OnInit {
  imgUrl=[
    '/assets/img/tiny/6.jpeg',
    '/assets/img/tiny/7.jpeg',
    '/assets/img/tiny/8.jpeg',
    '/assets/img/tiny/9.jpeg',
    '/assets/img/tiny/10.jpeg',
    '/assets/img/tiny/1.jpeg',
    '/assets/img/tiny/2.jpeg',
    '/assets/img/tiny/3.jpeg',
    '/assets/img/tiny/4.jpeg',
    '/assets/img/tiny/5.jpg',
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
